import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router'
import { AppShell } from './layout/AppShell.js'
import { Abrechnung } from './pages/Abrechnung.js'
import { Auftraege } from './pages/Auftraege.js'
import { Editionen } from './pages/Editionen.js'
import { Partner } from './pages/Partner.js'
import { PartnerDetail } from './pages/PartnerDetail.js'
import { ProxySeite } from './pages/Proxy.js'
import { SitzungProvider } from './session/SitzungContext.js'
// Einziger Stil-Einstieg, gemeinsam mit Kundenverwaltung und Kundenanwendung.
import '@nac2s/ui/oberflaeche.css'

/**
 * Verwaltung (netable) — ADR-0013.
 *
 * Partner anlegen und pflegen, Server koppeln, Preise, Mengen je Monat mit
 * Aufschluesselung je Kunde, Abrechnung zur Uebergabe an Autotask/weclapp,
 * Auftraege freigeben. Dieselbe Bauform wie die Kundenverwaltung.
 *
 * **Die Verwaltung sieht keine Kundendaten** ausser Namen und Mengen —
 * keine Anwender, Geraete, Rufnummern, Gespraeche (Projektstruktur.md §3).
 */

const wurzel = document.getElementById('root')
if (!wurzel) throw new Error('Wurzelelement #root nicht gefunden')

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <SitzungProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<Partner />} />
            <Route path="partner/:id" element={<PartnerDetail />} />
            <Route path="abrechnung" element={<Abrechnung />} />
            <Route path="auftraege" element={<Auftraege />} />
            <Route path="editionen" element={<Editionen />} />
            <Route path="proxy" element={<ProxySeite />} />
            <Route path="*" element={<NichtGefunden />} />
          </Route>
        </Routes>
      </SitzungProvider>
    </BrowserRouter>
  </StrictMode>,
)

function NichtGefunden() {
  return (
    <div className="px-6 py-8">
      <h1 className="font-display text-xl font-bold text-primary">Seite nicht gefunden</h1>
      <p className="mt-2 text-sm text-tertiary">Diese Adresse gibt es nicht.</p>
    </div>
  )
}
